<template>
  <v-container class="mt-3">
    <app-header :buttonAction="action" inside>
      <template v-slot:title>{{ data.title }}</template>
      <template v-slot:buttonText>Skip Intro</template>
    </app-header>
    <app-video-component v-if="data.lesson_file" class="my-10" :src="data.lesson_file" />
    <app-rich-text ref="editor" :body="JSON.parse(data.rich_text)">
      <template v-slot:title>{{ data.rich_title }}</template>
    </app-rich-text>
    <app-comment-group :uuid="data.comment_group" />
  </v-container>
</template>
<script>
import VideoComponent from "./../components/VideoComponent.vue";
import RichText from "./../components/RichText";
import Header from "./../components/Header.vue";
import { getLessonIntro, patchLessonProgress } from "@/api/api";
import CommentGroup from "../components/CommentGroup.vue";

export default {
  components: {
    appVideoComponent: VideoComponent,
    appRichText: RichText,
    appHeader: Header,
    appCommentGroup: CommentGroup,
  },
  data() {
    return {
      data: {
        rich_text: '{"type": "doc","content": []}',
      },
    };
  },
  methods: {
    async action() {
      let progress = this.$store.getters["progress/lesson"];
      if (!progress.teach_progress.intro_step) {
        progress.teach_progress.intro_step = true;
        const response = await patchLessonProgress(progress);
        if (response) {
          this.$store.commit("progress/lesson", response.data);
        }
      }
      this.$router.push({ name: "guided-lesson" });
    },
  },
  async created() {
    const response = await getLessonIntro(this.$store.getters["lesson/teacher_lesson"].intro_step);
    this.data = response.data;
  },
};
</script>
